var _path, _path2, _path3, _marker, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-us",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bd3d44",
    d: "M0 0h512v512H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 40,
    d: "M0 58h512M0 137h512M0 216h512M0 295h512M0 374h512M0 453h512"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#192f5d",
    d: "M0 0h390v275H0z"
  })), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "us-a",
    markerHeight: 30,
    markerWidth: 30
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 0 9.3 28.6L0 11h30L5.7 28.6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    markerMid: "url(#us-a)",
    d: "m0 0 18 11h65 65 65 65 66L51 39h65 65 65 65L18 66h65 65 65 65 66L51 94h65 65 65 65L18 121h65 65 65 65 66L51 149h65 65 65 65L18 177h65 65 65 65 66L51 205h65 65 65 65L18 232h65 65 65 65 66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsflag);
export default __webpack_public_path__ + "static/media/usflag.9acbcf1017616e2140a1935111c50f28.svg";
export { ForwardRef as ReactComponent };